<script lang="ts">
import type { Snippet } from 'svelte'

/** Inner content column for a study slide: `.inn.sg` in `StudySlidePresentation` (max-width, staggered children). */
interface Props {
  maxWidth?: string
  textAlign?: 'left' | 'center' | 'right'
  /** Extra classes on the content wrapper (e.g. `cover-inn`, route-specific). */
  contentClass?: string
  style?: string
  children: Snippet
}

let {
  maxWidth = '960px',
  textAlign = 'left',
  contentClass = '',
  style: extraStyle = '',
  children,
}: Props = $props()

const combinedStyle = $derived.by(() => {
  const align = textAlign === 'left' ? '' : `text-align:${textAlign};`
  const base = [`max-width:${maxWidth}`, align, extraStyle].filter(Boolean).join(';')
  return base.endsWith(';') ? base : `${base};`
})
</script>

<div class="inn sg {contentClass}" style={combinedStyle}>
  {@render children()}
</div>
